import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { Box, Button, Container, FormControl, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { MuiTheme } from "../styles/MuiDataTableStyle";
import {
  createPatient,
  getFinancerPlans,
  getPatients,
  validarDniExiste,
  validarMailExiste,
  validatePatientExist,
} from "../services/patientsService";
import { useStateAuthValue } from "../context/AuthState";
import { useToast } from "../context/Toast/ToastProvider";
import { showToast, ToastType } from "../utils/ToastUtil";
import { LoadingModal } from "../components/Modals/LoadingModal";
import { SeePatientDetailsModal } from "../components/Modals/SeePatientDetailsModal";
import { Field, Form, Formik } from "formik";
import {
  DatePickerField,
  FormikField,
  SelectObjectField,
} from "../components/FormFields";
import * as Yup from "yup";
import {
  getPrepaidHealth,
  getPrepaidHealthCategoryByPrepaidHealth,
} from "../services/prepaidHealthService";
import { useNavigate } from "react-router-dom";
import { FidgetSpinner } from "react-loader-spinner";
import { Circle } from "@mui/icons-material";
import { BaseModal } from "../components/Modals/BaseModal";
import { validate } from "@material-ui/pickers";
import { getProducts } from "../services/productService";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";

const NewSaleTMotos = () => {
  const [{ userToken }] = useStateAuthValue();
  const toastDispatch = useToast();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const displayError = (msg) =>
    showToast(toastDispatch, msg, ToastType.ERROR, ToastType.ERROR);
  const [patient, setPatient] = useState({
    nombre: undefined,
    apellido: undefined,
    documento: undefined,
    idPlan: undefined,
    email: undefined,
    sexo: undefined,
    product: undefined,
    cUITCUIL: undefined,
    fechaDeNacimiento: undefined,
    telCelular: undefined,
    tarjetaTitular: "",
    tarjetaNumero: "",
    tarjetaFechaVencimiento: "",
    cbu: "",
    cbuTitular: "",
    concesionario: "Medinet",
    nombreVendedor: "Operador Medinet",
    idAsistenciaCertificado: undefined,
  });
  const getPatientSchema = (currentPaymentType) =>
    Yup.object().shape({
      ...Object.keys(patient).reduce((schema, key) => {
        // Optional fields
        if (key === "cUITCUIL" || key === "idAsistenciaCertificado") {
          schema[key] = Yup.string().optional();
        }

        // Validación dinámica por tipo de pago
        else if (key === "cbu" || key === "cbuTitular") {
          if (currentPaymentType?.id === 1) {
            schema["cbu"] = Yup.string().required("CBU requerido");
            schema["cbuTitular"] = Yup.string().required(
              "Titular CBU requerido"
            );
          } else {
            schema["cbu"] = Yup.string().optional();
            schema["cbuTitular"] = Yup.string().optional();
          }
        } else if (
          key === "tarjetaNumero" ||
          key === "tarjetaTitular" ||
          key === "tarjetaFechaVencimiento"
        ) {
          if (currentPaymentType?.id === 2) {
            schema["tarjetaNumero"] = Yup.string().required(
              "N° Tarjeta requerido"
            );
            schema["tarjetaTitular"] = Yup.string().required(
              "Titular Tarjeta requerido"
            );
            schema["tarjetaFechaVencimiento"] = Yup.string().required(
              "Fecha Vencimiento requerida"
            );
          } else {
            schema["tarjetaNumero"] = Yup.string().optional();
            schema["tarjetaTitular"] = Yup.string().optional();
            schema["tarjetaFechaVencimiento"] = Yup.string().optional();
          }
        }

        // Campos requeridos por defecto
        else {
          schema[key] = Yup.string().required("No debe quedar vacío");
        }

        return schema;
      }, {}),
    });

  const [financerPlansList, setFinancerPlansList] = useState([
    {
      name: `CLASSIC`,
      id: 1,
    },
    {
      name: `PLUS`,
      id: 2,
    },
    {
      name: `PREMIUM`,
      id: 3,
    },
    {
      name: `ASISTENCIA MEDICA`,
      id: 5,
    },
    {
      name: `TLV ASISTENCIA`,
      id: 6,
    },
    {
      name: `TLV CLASSIC`,
      id: 7,
    },
    {
      name: `TLV PLUS`,
      id: 8,
    },
    {
      name: `TLV PREMIUM`,
      id: 9,
    },
  ]);
  const [productList, setProductList] = useState([]);
  const [currentFinancerPlan, setCurrentFinancerPlan] = useState({});
  const [currentProdut, setCurrentProduct] = useState({});
  const genderList = [
    {
      name: `Hombre`,
      id: 1,
    },
    {
      name: `Mujer`,
      id: 2,
    },
    {
      name: `No binario`,
      id: 3,
    },
  ];
  const paymentType = [
    {
      name: `CBU`,
      id: 1,
    },
    {
      name: `Tarjeta`,
      id: 2,
    },
  ];
  const [currentPaymentType, setCurrentPaymentType] = useState(null);

  const showError = (msgError) => {
    showToast(toastDispatch, msgError, ToastType.ERROR, ToastType.ERROR);
  };
  const formikSetValues = useRef(null);

  const fetchProduts = async () => {
    setLoading(true);
    getProducts(userToken, showError).then((element) => {
      setProductList(element.data);
      setLoading(false);
    });
  };

  const fetchFinancerPlans = async () => {
    const response = await getFinancerPlans(
      userToken,
      showError,
      currentProdut.name
    );
    let _financerPlansList = [];
    response?.data?.map((plan) => {
      if (plan.financerId == "32333636-3631-3338-2d33-3536362d3336") {
        _financerPlansList = [
          ..._financerPlansList,
          {
            name: `${plan.planName}`,
            id: plan.id,
          },
        ];
      }
    });
    let _agreementFinancerPlansList = [];
    response?.data?.map((plan) => {
      if (plan.financerId != "32333636-3631-3338-2d33-3536362d3336") {
        _agreementFinancerPlansList = [
          ..._agreementFinancerPlansList,
          {
            name: `${plan.planName} - ${plan.financer.financerName}`,
            id: plan.id,
          },
        ];
      }
    });
    _agreementFinancerPlansList.sort((a, b) => {
      // Comparamos los nombres en minúsculas para asegurar una comparación insensible a mayúsculas/minúsculas
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if (nameA < nameB) {
        return -1; // nameA debe ir antes que nameB
      }
      if (nameA > nameB) {
        return 1; // nameA debe ir después que nameB
      }
      return 0; // Los nombres son iguales
    });
    _financerPlansList = [
      ..._financerPlansList,
      ..._agreementFinancerPlansList,
    ];
    //setFinancerPlansList(_financerPlansList);
  };

  useEffect(() => {
    //fetchFinancerPlans();
    fetchProduts();
    setCurrentFinancerPlan({});
    setCurrentProduct({});
  }, []);

  const [validation, setValidation] = useState({
    emailError: null,
    dniError: null,
  });
  const handleCreatePatient = async (values) => {
    values.idPlan = currentFinancerPlan.id;
    //return;
    setLoading(true);
    if (currentPaymentType?.id === 1) {
      values.tarjetaNumero = "";
      values.tarjetaFechaVencimiento = "";
      values.tarjetaTitular = "";
    } else if (currentPaymentType?.id === 2) {
      values.cbu = "";
      values.cbuTitular = "";
    } else {
      values.tarjetaNumero = "";
      values.tarjetaFechaVencimiento = "";
      values.tarjetaTitular = "";
      values.cbu = "908349283904890234sdasd";
      values.cbuTitular = "OPERADOR MEDILINE";
    }
    if (values.idPlan <= 5) {
      let response = null;
      await validatePatientExist(
        userToken,
        values.email,
        values.documento,
        values.product
      ).then(async (_response) => {
        response = _response;
      });
      if (response.documento != "Ok") {
        setLoading(false);
        showToast(
          toastDispatch,
          "DNI " + response.documento,
          ToastType.ERROR,
          ToastType.ERROR
        );
      }
      if (response.mail != "Ok") {
        setLoading(false);
        showToast(
          toastDispatch,
          "Correo " + response.mail,
          ToastType.ERROR,
          ToastType.ERROR
        );
      }
      setValidation({
        dniError: response.documento != "Ok" && "DNI " + response.documento,
        emailError: response.mail != "Ok" && "Correo " + response.mail,
      });
      if (response.documento != "Ok" && response.mail != "Ok") {
        return;
      }
    }

    const now = new Date();
    const idAsistenciaCertificado =
      now.getHours().toString().padStart(2, "0") +
      now.getMinutes().toString().padStart(2, "0") +
      now.getDate().toString().padStart(2, "0") +
      (now.getMonth() + 1).toString().padStart(2, "0") +
      now.getFullYear().toString().slice(-2);
    values.idAsistenciaCertificado = idAsistenciaCertificado;
    // setLoading(false);
    // return;
    await createPatient(userToken, values, displayError).then((e) => {
      if (e != null) {
        showToast(
          toastDispatch,
          "Se creo con exito",
          ToastType.SUCCESS,
          ToastType.SUCCESS
        );
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    });
  };

  const ComponenteCBU = () => (
    <>
      <FormikField
        inputProps={{
          onWheel: (e) => e.target.blur(),
        }}
        type="number"
        name="cbu"
        label="CBU *"
      />
      <FormikField name="cbuTitular" label="Titular CBU *" />
    </>
  );
  const ComponenteTarjeta = ({ values, errors, setFieldValue }) => (
    <>
      <FormikField
        inputProps={{
          onWheel: (e) => e.target.blur(),
        }}
        type="number"
        name="tarjetaNumero"
        label="N° Tarjeta *"
      />
      <FormikField name="tarjetaTitular" label="Titular Tarjeta *" />
      <FormControl fullWidth>
        <DatePicker
          views={["year", "month"]} // 👈 esto hace que solo se seleccione Año y Mes
          label="Fecha Vencimiento *"
          value={
            values?.tarjetaFechaVencimiento
              ? dayjs(values.tarjetaFechaVencimiento, "YYYY-MM")
              : null
          }
          onChange={(value) => {
            if (value) {
              setFieldValue("tarjetaFechaVencimiento", value.format("YYYY-MM"));
            } else {
              setFieldValue("tarjetaFechaVencimiento", "");
            }
          }}
          slotProps={{
            textField: { variant: "standard", disabled: true },
          }}
          sx={{ width: "100%" }}
        />
        {errors.tarjetaFechaVencimiento && (
          <p style={{ color: "red" }}>{errors.tarjetaFechaVencimiento}</p>
        )}
      </FormControl>
    </>
  );

  return (
    <Container className={"create-patient-modal"}>
      <h3>Alta de socios desde Tmotos</h3>
      <p>Los campos con * son de caracter obligatorio.</p>
      <Formik
        onSubmit={(values) => {
          handleCreatePatient(values);
        }}
        initialValues={patient}
        validationSchema={getPatientSchema(currentPaymentType)}
      >
        {({
          isValid,
          values,
          setValues,
          setFieldValue,
          errors,
          validateForm,
          setErrors,
        }) => {
          formikSetValues.current = setValues;
          return (
            <Form>
              <div
                style={{
                  display: "grid",
                  gridGap: "20px",
                }}
                className="responsive-form-grid"
              >
                <FormikField name="apellido" label="Apellido *" />
                <FormikField name="nombre" label="Nombre *" />
                <FormikField
                  name="documento"
                  errorMsg={validation.dniError}
                  label="DNI *"
                  type="number"
                  onFocus={() => {
                    setValidation({ ...validation, dniError: null });
                  }}
                  inputProps={{
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <FormikField
                  inputProps={{
                    onWheel: (e) => e.target.blur(),
                  }}
                  type="number"
                  name="cUITCUIL"
                  label="CUIT/CUIL"
                />

                <FormControl>
                  <DatePickerField
                    label="Fecha Nacimiento *"
                    value={values?.fechaDeNacimiento}
                    slotProps={{
                      textField: { variant: "standard", disabled: true },
                    }}
                    sx={{ width: "100%" }}
                    onChange={(value) => {
                      setFieldValue(
                        "fechaDeNacimiento",
                        value.format("YYYY-MM-DDT00:00:00Z")
                      );
                    }}
                  />
                  {errors.fechaDeNacimiento && (
                    <p style={{ color: "red" }}>{errors.fechaDeNacimiento}</p>
                  )}
                </FormControl>
                <SelectObjectField
                  label="Sexo *"
                  setValue={(e) => {
                    setValues({ ...values, sexo: e.id });
                  }}
                  value={genderList.filter((fp) => fp.id == values.sexo)[0]}
                  data={genderList}
                  className="field"
                  errorMsg={errors.sexo}
                  isError={errors.sexo}
                />
                <FormikField
                  name="email"
                  label="Correo *"
                  errorMsg={validation.emailError}
                  onFocus={() => {
                    setValidation({ ...validation, emailError: null });
                  }}
                />
                <FormikField
                  type="number"
                  name="telCelular"
                  label="Celular *"
                  inputProps={{
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <SelectObjectField
                  label="Producto *"
                  setValue={(e) => {
                    setCurrentProduct(e);
                    setCurrentFinancerPlan({});
                    fetchFinancerPlans();
                    setValues({
                      ...values,
                      product: e.name,
                      idPlan: "",
                    });
                  }}
                  value={currentProdut}
                  data={productList || []}
                  className="field"
                  errorMsg={errors.product}
                  isError={errors.product}
                />
                <SelectObjectField
                  label="Plan *"
                  setValue={(e) => {
                    setValues({ ...values, idPlan: e.id });
                    setCurrentFinancerPlan(e);
                  }}
                  value={currentFinancerPlan}
                  data={
                    currentProdut?.name == "televet"
                      ? financerPlansList.filter((plan) => plan.id > 5)
                      : financerPlansList || []
                  }
                  className="field"
                  errorMsg={errors.idPlan}
                  isError={errors.idPlan}
                  disabled={!values.product}
                />
                <SelectObjectField
                  label="Tipo de pago"
                  setValue={(e) => {
                    setCurrentPaymentType(e);
                    setErrors({
                      ...errors,
                      tarjetaFechaVencimiento: null,
                      tarjetaTitular: null,
                      tarjetaNumero: null,
                      cbu: null,
                      cbuTitular: null,
                    });
                  }}
                  value={currentPaymentType}
                  data={paymentType}
                  className="field"
                />

                {currentPaymentType?.id == 1 && <ComponenteCBU />}
                {currentPaymentType?.id == 2 && (
                  <ComponenteTarjeta
                    values={values}
                    setFieldValue={setFieldValue}
                    errors={errors}
                  />
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >
                <Button
                  disabled={
                    Object.keys(errors).length != 0 ||
                    validation.dniError ||
                    validation.dniError
                  }
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  style={{
                    backgroundColor: "#002c54",
                    borderRadius: "20px",
                    textTransform: "capitalize",
                  }}
                >
                  Guardar
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
      {loading && <LoadingModal />}
    </Container>
  );
};

export default NewSaleTMotos;
